<h2 mat-dialog-title class="default-dialog-header font-weight-normal">
	Restore {{ data?.carrierName }} to workflows
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="p-8" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">
		<div *ngIf="loading">Loading removed workflows…</div>

		<div *ngIf="!loading && memberships.length === 0">
			This carrier has no workflows that were removed by exclusion.
		</div>

		<div
			*ngIf="!loading && memberships.length > 0"
			fxLayout="column"
			fxLayoutGap="0.5rem"
			class="full-width"
		>
			<div>Select the workflows to restore this carrier to:</div>
			<mat-checkbox *ngFor="let m of memberships" [(ngModel)]="m.selected">
				{{ m.projectName }}
			</mat-checkbox>

			<mat-form-field style="width: 100%">
				<mat-label>Reason</mat-label>
				<textarea
					[formControl]="reasonControl"
					matInput
					rows="3"
					placeholder="Why is this carrier being restored to these workflows?"
					required
				></textarea>
				<mat-error *ngIf="reasonControl?.hasError('required')">A reason is required.</mat-error>
			</mat-form-field>
		</div>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end center">
		<button (click)="closeDialog()" type="button" mat-button class="m-r-1 primary-text">
			Cancel
		</button>
		<button
			(click)="restore()"
			color="primary"
			mat-raised-button
			[disabled]="loading || saving || memberships.length === 0"
		>
			Restore
		</button>
	</div>
</mat-dialog-actions>
